import axios from "axios";
import { account } from "../../shared/Utils";

export const baseURL = `${process.env.REACT_APP_API_LOGISTICA}/api/`;

axios.interceptors.request.use(
  (config) => {
    const token = account.getToken(); //window.localStorage.getItem(encryptStringHash("token"));
    if (token)
      Object.assign(config?.headers, { Authorization: `Bearer ${token}` });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const responseBody = (response) => response?.data;
const requests = {
  get: (url) =>
    axios
      .get(url, {
        baseURL,
      })
      .then(responseBody),
  post: (url, body) =>
    axios
      .post(url, body ?? {}, {
        baseURL,
      })
      .then(responseBody),
  postFormData: (url, formData) =>
    axios
      .post(url, formData, {
        baseURL,
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody),
  put: (url, body) =>
    axios
      .put(url, body, {
        baseURL,
      })
      .then(responseBody),
  putFormData: (url, formData) =>
    axios
      .put(url, formData, {
        baseURL,
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody),
  patch: (url, body) =>
    axios
      .patch(url, body, {
        baseURL,
      })
      .then(responseBody),
  delete: (url) =>
    axios
      .delete(url, {
        baseURL,
      })
      .then(responseBody),
  download: (url, name, data) =>
    axios
      .post(url, data, {
        baseURL,
        responseType: "blob",
        headers:
          data instanceof FormData
            ? { "Content-Type": "multipart/form-data" }
            : { "Content-Type": "application/json" },
      })
      .then((response) => {
        console.log("Download");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
      }),

  postFileBlob: (url, data) =>
    axios
      .post(url, data, {
        baseURL,
        responseType: "blob",
        headers:
          data instanceof FormData
            ? { "Content-Type": "multipart/form-data" }
            : { "Content-Type": "application/json" },
      })
      .then((response) => {
        return response;
      }),

  getFileBlob: (url) =>
    axios
      .get(url, {
        baseURL,
        responseType: "blob",
      })
      .then((response) => {
        return response;
      }),


  showFileNewWindow: (url) =>
    axios.get(url, {
      baseURL,
      responseType: "blob"
    })
      .then((response) => {
        console.log("Download", response);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        window.open(url, '_blank');
      }),
};

export default requests;
